export class AutoSequenciaSerieEntity {
  serie = null;
  sequencia = null;

  constructor(autoSequeciaSerie) {
    this.serie = autoSequeciaSerie.serieDocumento;
    this.sequencia = autoSequeciaSerie.numeroFinal;
  }
}
